import { Component, inject, Inject, Input } from '@angular/core';
import { MOTIF_DIALOG_DATA, MotifModalModule, MotifModalRef } from '@ey-xd/ng-motif';


@Component({
  selector: 'app-confirm-common',
  standalone: true,
  imports: [MotifModalModule],
  templateUrl: './confirm-common.component.html',
  styleUrl: './confirm-common.component.scss'
})
export class ConfirmCommonComponent {
  readonly dialogRef = inject(MotifModalRef<ConfirmCommonComponent>);

}
